export const FontSelector = [
  {
    label: 'Haffer Regular',
    value: 'font-haffer',
  },
  {
    label: 'Haffer Italic',
    value: 'font-hafferItalic',
  },
  {
    label: 'Haffer Bold',
    value: 'font-hafferBold',
  },
  {
    label: 'Haffer Bold Italic',
    value: 'font-hafferBoldItalic',
  },
  {
    label: 'Tiempos',
    value: 'font-tiempos',
  },
  {
    label: 'Tiempos Italic',
    value: 'font-tiempos italic',
  },
];

export const desktopFontSelector = [
  {
    label: 'Haffer Regular',
    value: 'sm:font-haffer',
  },
  {
    label: 'Haffer Italic',
    value: 'sm:font-hafferItalic',
  },
  {
    label: 'Haffer Bold',
    value: 'sm:font-hafferBold',
  },
  {
    label: 'Haffer Bold Italic',
    value: 'sm:font-hafferBoldItalic',
  },
  {
    label: 'Tiempos',
    value: 'sm:font-tiempos',
  },
  {
    label: 'Tiempos Italic',
    value: 'sm:font-tiempos sm:italic',
  },
];

export const mobileFontSelector = [
  {
    label: 'Haffer Regular',
    value: 'max-sm:font-haffer',
  },
  {
    label: 'Haffer Italic',
    value: 'max-sm:font-hafferItalic',
  },
  {
    label: 'Haffer Bold',
    value: 'max-sm:font-hafferBold',
  },
  {
    label: 'Haffer Bold Italic',
    value: 'max-sm:font-hafferBoldItalic',
  },
  {
    label: 'Tiempos',
    value: 'max-sm:font-tiempos',
  },
  {
    label: 'Tiempos Italic',
    value: 'max-sm:font-tiempos max-sm:italic',
  },
];